import {
    Card, CardBody, CardHeader, Col, Form, Row, FormGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from "reactstrap";
import { LabelText } from "../Utils/Input";
import formSchema from "../Utils/schema.json";
import { Formik } from "formik";
import { validationSchemaForTelcoSimulate } from "./constants/validationSchema";
import { RenderField } from "../Utils/renderFields";
import CommonButton from "../Utils/CommonButton";
import { useLocation, useNavigate } from "react-router-dom";
import { customerIdData } from "./constants/constantFunctionsView";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Loader } from "../Utils/Loader";
import { initiateSessionApiCall, optionsForSubscriptionId, uomOptions } from "./constants/SessionFunctions";
import { fetchEventTypes } from "../../slices/sessions/eventType/thunk";
import { getAllQuota } from '../../slices/QuotaManagement/thunk';
import SelectField from '../Utils/SelectField';
import { getAllAttribute } from "../../slices/services/addservice/provisionalattribute/thunk";
import { updateSessionApiCall } from "./constants/UpdateSessionjson";
import { hasPermission } from "../Utils/UtilityFunctions";

export const ActiveSimulate = ({
    showForm,
    setShowForm,
    sessionAction,
    setSessionAction,
    sessionInfo,
    setUpdateSession,
    terminateSessions,
    setButtonInitiateSession
}) => {
    const navigate = useNavigate();
    const customerId = customerIdData();
    const dispatch = useDispatch();
    const location = useLocation();
    const [modalForSimulate, setModalForSimulate] = useState(false);
    const [loading, setLoading] = useState(false);
    const [eventTypeData, setEventTypeData] = useState();
    const [uomData, setUomData] = useState();
    const [match, setMatch] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [localSessionAction, setLocalSessionAction] = useState('initiate');
    const [showMandatory, setShowMandatory] = useState(false);

    const [open, setOpen] = useState('');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    const fullName = location?.state?.Name;
    const isView = location.pathname.includes('view-customer') || location.pathname.includes('simulate');
    const showDropdown = location.pathname.includes('simulate') || location.pathname.includes('view-customer');
    const currentSessionAction = showDropdown ? localSessionAction : (sessionAction || 'initiate');
    const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

    const handleSessionAction = (action) => {
        setLocalSessionAction(action);
        setDropdownOpen(false);
    };

    const getActionDisplayText = () => {
        switch (currentSessionAction) {
            case 'initiate':
                return 'Initiate Session';
            case 'update':
                return 'Update Session';
            case 'terminate':
                return 'Terminate Session';
            default:
                return 'Select Action';
        }
    };

    const initialValues = {
        subscriptionId: '',
        usageEventType: '',
        sessionId: '',
        sessionTime: null,
        requestedUnits: '',
        usedUnits: '',
        uom: '',
        attributes: [{ name: '', value: '' }],
        sequence: ''
    };

    let eventType = useSelector((state) => state.EventType.eventType);
    const customerData = useSelector((state) => state.FetchCustomer.fetchCustomer)
    const optionsOfSubscriptions = optionsForSubscriptionId(customerData?.subscriptionList);
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const quotaPermission = hasPermission(permissionsMap, "charging", "quota")
    const simulateOptions = [
        {
            name: "subscriptionId",
            value: "ActiveSimulate",
            options: optionsOfSubscriptions,
        },
        eventTypeData,
        uomData,
    ];
    const attributes = useSelector((state) => state.Provisional.provisional);
    const filteredAttributes = attributes.filter(attr =>
        (attr.type === "customer" || attr.type === "usage") &&
        attr.valueType !== "list"
    );
    const attributeNameOptions = filteredAttributes.map(attr => ({
        value: attr.name,
        label: attr.name,
        valueType: attr.valueType,
    }));
    useEffect(() => {
        if (quotaPermission)
            dispatch(getAllQuota(setLoading))
    }, [dispatch]);
    const quota = useSelector((state) => state?.GetAllQuota?.quota)
    useEffect(() => {
        dispatch(getAllAttribute(setLoading));
    }, [dispatch]);

    const getFieldHelperText = (field) => {
        const fieldName = field.name;
        if (field.placeholder) {
            return field.placeholder;
        }
        return `Enter ${field.label}`;
    };
    const getHelperTextClass = (field, touched, errors) => {
        const fieldName = field.name;
        const baseClass = "d-block ms-0 rv-sub-label";
        if (touched[fieldName] && errors[fieldName]) {
            return `${baseClass} rv-label-danger`;
        }
        return `${baseClass} rv-label-muted`;
    };
    const addAttribute = (setFieldValue, values) => {
        const currentAttributes = values.attributes || [];
        const hasInvalidAttributes = currentAttributes.some(attr => !attr.name || !attr.value);
        if (hasInvalidAttributes) {
            return;
        }
        const newAttributes = [...values.attributes, { name: '', value: '' }];
        setFieldValue('attributes', newAttributes);
    };
    const removeAttribute = (index, setFieldValue, values) => {
        const newAttributes = values.attributes.filter((_, i) => i !== index);
        setFieldValue('attributes', newAttributes);
    };
    const handleAttributeChange = (index, field, value, setFieldValue, values) => {
        const newAttributes = [...values.attributes];
        if (field === "name") {
            newAttributes[index].name = value;
            const selectedAttribute = filteredAttributes.find(attr => attr.name === value?.value);
            if (selectedAttribute?.default) {
                newAttributes[index].value = selectedAttribute.default;
            } else {
                newAttributes[index].value = "";
            }
        } else {
            newAttributes[index][field] = value;
        }

        setFieldValue("attributes", newAttributes);
    };

    const handleFormSubmit = (value, { resetForm }) => {
        const invalidAttribute = value.attributes?.some(attr => {
            const hasName = attr.name && attr.name.value;
            const hasValue = attr.value !== undefined && attr.value !== "";
            // Invalid if name exists but value missing OR value exists but name missing
            return (hasName && !hasValue) || (!hasName && hasValue);
        });
        if (invalidAttribute) {
            return; // Stop form submission
        }
        if (currentSessionAction === 'update' || currentSessionAction === 'terminate') {
            try {
                updateSessionApiCall(
                    value,
                    dispatch,
                    setLoading,
                    customerId,
                    setUpdateSession,
                    isView,
                    sessionInfo,
                    terminateSessions,
                    setButtonInitiateSession,
                    currentSessionAction,
                    setShowForm,
                    showDropdown ? () => handleFormReset(resetForm) : null, // Pass reset callback
                    toggle,
                );
            } catch (error) {
                console.error("❌ ERROR in updateSessionApiCall:", error);
            }
        } else {
            if (typeof initiateSessionApiCall !== 'function') {
                console.error("❌ ERROR: initiateSessionApiCall is not a function!");
                return;
            }
            try {
                initiateSessionApiCall(
                    value,
                    dispatch,
                    setLoading,
                    navigate,
                    customerId,
                    fullName,
                    setShowForm,
                    isView,
                    showDropdown ? () => handleFormReset(resetForm) : null,
                    setSessionAction,// Pass reset callback for initiate as well
                    toggle,
                );
            } catch (error) {
                console.error("❌ ERROR in initiateSessionApiCall:", error);
            }
        }
    };

    const handleFormReset = (resetForm) => {
        resetForm({
            values: initialValues
        });
        setEventTypeData(null);
        setUomData(null);
        setMatch(false);
    };

    return (
        <>
            <Accordion open={open} toggle={toggle}>
                <AccordionItem>
                    <AccordionHeader targetId="1">Simulate Session</AccordionHeader>
                    <AccordionBody accordionId="1">
                        {(
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchemaForTelcoSimulate(match, currentSessionAction)}
                                onSubmit={handleFormSubmit}
                                enableReinitialize={false}
                                key={`${currentSessionAction}-form`}
                            >
                                {({
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    errors,
                                    touched,
                                    values,
                                    setFieldValue,
                                    setFieldTouched,
                                    resetForm,
                                }) => {
                                    useEffect(() => {
                                        if (values?.subscriptionId?.value) {
                                            dispatch(fetchEventTypes(values?.subscriptionId?.value, setLoading, setEventTypeData));
                                        }
                                        if (currentSessionAction !== "update" && currentSessionAction !== "terminate") {
                                            setFieldValue("usageEventType", "");
                                        }
                                    }, [values?.subscriptionId?.value]);

                                    useEffect(() => {
                                        if (values?.usageEventType?.value) {
                                            const matchedQuota = quota?.find(
                                                (item) => item.usageEventType === values.usageEventType.value
                                            );
                                            setMatch(matchedQuota);
                                            let UOMOptions = [];
                                            UOMOptions = uomOptions(eventType, values?.usageEventType?.value);
                                            if (currentSessionAction !== "update" && currentSessionAction !== "terminate") {
                                                setFieldValue("uom", "");
                                            }
                                            const extraObject = {
                                                name: "uom",
                                                value: "ActiveSimulate",
                                                options: UOMOptions,
                                            };
                                            setUomData(extraObject);
                                        }
                                    }, [values?.usageEventType?.value]);

                                    useEffect(() => {
                                        if (values?.usageEventType?.value) {
                                            setMatch(quota?.find(
                                                (item) =>
                                                    item.usageEventType === values.usageEventType.value
                                            ))
                                            if (match) {
                                                formSchema.forEach((section) => {
                                                    if (section.title === "ActiveSimulate" && section.sections) {
                                                        section.sections.forEach((subSection) => {
                                                            subSection.fields.forEach((field) => {

                                                            });
                                                        });
                                                    }
                                                })
                                            }
                                        }
                                    }, [values?.usageEventType?.value]);

                                    useEffect(() => {
                                        if (values?.attributes) {
                                            const isMandatory = values?.attributes?.some((i => i?.name || i?.value))
                                            setShowMandatory(isMandatory);
                                        }
                                    }, [values?.attributes[0]?.value]);

                                    return (
                                        <Form id="csms" className="needs-validation" onSubmit={handleSubmit}>
                                            <div>
                                                {loading && <Loader />}
                                                {formSchema.map((section, sectionIndex) =>
                                                    section.title === "ActiveSimulate" &&
                                                    section.sections &&
                                                    section.sections.map((subSection, subSectionIndex) =>
                                                        subSection?.sectionTitle ? (
                                                            <Card key={subSectionIndex} className="bg-white shadow-none">
                                                                {(showDropdown || isView) && (
                                                                    <div className="pb-0 px-3">
                                                                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                                                            <DropdownToggle
                                                                                caret
                                                                                className="d-flex bg-primary text-white rounded-1 px-4 py-2 align-items-center"
                                                                            >
                                                                                {getActionDisplayText()}
                                                                            </DropdownToggle>
                                                                            <DropdownMenu>
                                                                                {[
                                                                                    { value: 'initiate', label: 'Initiate' },
                                                                                    { value: 'update', label: 'Update' },
                                                                                    { value: 'terminate', label: 'Terminate' }
                                                                                ]
                                                                                    .filter(action => action.value !== currentSessionAction)
                                                                                    .map((action, index, filteredArray) => (
                                                                                        <DropdownItem
                                                                                            key={action.value}
                                                                                            className={`text-primary ${index < filteredArray.length - 1 ? 'border-bottom' : ''}`}
                                                                                            onClick={() => handleSessionAction(action.value)}
                                                                                        >
                                                                                            {action.label}
                                                                                        </DropdownItem>
                                                                                    ))}
                                                                            </DropdownMenu>
                                                                        </Dropdown>
                                                                    </div>
                                                                )}
                                                                <CardBody>
                                                                    <Row key={sectionIndex}>
                                                                        <Col lg={12}>
                                                                            <Row className="gy-4">
                                                                                {subSection.fields
                                                                                    .filter((field) => {
                                                                                        if (field.name === "sequence" && currentSessionAction === "initiate") {
                                                                                            return false
                                                                                        }
                                                                                        if (field.name === "usedUnits" && currentSessionAction === "initiate") {
                                                                                            return false
                                                                                        }
                                                                                        if (field.name === "requestedUnits" && currentSessionAction === "terminate") {
                                                                                            return false
                                                                                        }
                                                                                        return true;
                                                                                    })
                                                                                    .map((field, fieldIndex) => {
                                                                                        return (
                                                                                            <Col
                                                                                                xxl={3}
                                                                                                md={6}
                                                                                                lg={3}
                                                                                                key={`${subSectionIndex}-one-${fieldIndex}`}
                                                                                                className="pe-0"
                                                                                            >
                                                                                                <FormGroup>
                                                                                                    <LabelText
                                                                                                        htmlFor={field.name}
                                                                                                        classLabelName={"ms-0 rv-form-label"}
                                                                                                        className={field.required ? "text-danger" : ""}
                                                                                                        displayText={field.label}
                                                                                                        important={field.required ? "*" : ""}
                                                                                                    />
                                                                                                    <LabelText
                                                                                                        htmlFor={field.name}
                                                                                                        classLabelName={getHelperTextClass(field, touched, errors)}
                                                                                                        displayText={touched[field.name] && errors[field.name] ? errors[field.name] : getFieldHelperText(field)}
                                                                                                    />
                                                                                                    <RenderField
                                                                                                        field={field}
                                                                                                        handleChange={handleChange}
                                                                                                        handleBlur={handleBlur}
                                                                                                        values={values}
                                                                                                        touched={touched}
                                                                                                        errors={errors}
                                                                                                        setFieldTouched={setFieldTouched}
                                                                                                        setFieldValue={setFieldValue}
                                                                                                        options={simulateOptions}
                                                                                                    />
                                                                                                </FormGroup>
                                                                                            </Col>
                                                                                        );
                                                                                    })}
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    {currentSessionAction !== "terminate" && (
                                                                        <Row className="mt-4">
                                                                            <Col lg={12}>
                                                                                <div className=" mb-3">
                                                                                    <h4 className="card-title mb-3">Attributes</h4>
                                                                                </div>
                                                                                <Row className="gy-4 mb-3 align-items-end border-bottom">
                                                                                    <Col xxl={4} md={6} lg={4} className="pe-0">
                                                                                        <LabelText
                                                                                            htmlFor={`attributesname`}
                                                                                            classLabelName={"ms-0 rv-form-label"}
                                                                                            displayText="Attribute Name"
                                                                                            className="text-danger"
                                                                                            important={showMandatory ? "*" : ""}
                                                                                        /></Col>
                                                                                    <Col xxl={4} md={6} lg={4} className="pe-0">
                                                                                        <LabelText
                                                                                            htmlFor={`attributesvalue`}
                                                                                            classLabelName={"ms-0 rv-form-label"}
                                                                                            displayText="Value"
                                                                                            className="text-danger"
                                                                                            important={showMandatory ? "*" : ""}
                                                                                        /></Col></Row>
                                                                                {values?.attributes && values?.attributes?.length > 0 ? (
                                                                                    values?.attributes.map((attribute, attributeIndex) => {
                                                                                        return (
                                                                                            <Row key={attributeIndex} className="gy-4 mb-2 align-items-end">
                                                                                                <Col xxl={4} md={6} lg={4} className="pe-0">
                                                                                                    <FormGroup>
                                                                                                        <SelectField
                                                                                                            name={`attributes[${attributeIndex}].name`}
                                                                                                            options={attributeNameOptions}
                                                                                                            handleChange={(selectedOption) =>
                                                                                                                handleAttributeChange(attributeIndex, 'name', selectedOption, setFieldValue, values)
                                                                                                            }
                                                                                                            value={attribute.name || ''}
                                                                                                            placeholder="Select Attribute Name"
                                                                                                            isRVStyle={true}
                                                                                                            className={attribute?.value && !attribute?.name ? "error-input" : ""}
                                                                                                        />
                                                                                                    </FormGroup>
                                                                                                </Col>
                                                                                                <Col xxl={4} md={6} lg={4} className="pe-0">
                                                                                                    <FormGroup>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            name={`attributes[${attributeIndex}].value`}
                                                                                                            id={`attributes[${attributeIndex}].value`}
                                                                                                            className={`form-control ${!attribute?.value && attribute?.name ? "error-input" : ""}`}
                                                                                                            placeholder="Enter value"
                                                                                                            value={attribute.value || ""}
                                                                                                            onChange={(e) => {
                                                                                                                let value = e.target.value;
                                                                                                                let isValid = true;

                                                                                                                switch (attribute?.name?.valueType) {
                                                                                                                    case "integer":
                                                                                                                        isValid = value === "" || /^-?\d+$/.test(value);
                                                                                                                        break;
                                                                                                                    case "float64":
                                                                                                                        isValid = value === "" || /^-?\d*(\.\d+)?$/.test(value);
                                                                                                                        break;
                                                                                                                    case "bool":
                                                                                                                        // isValid = value === "" || /^(true|false)$/i.test(value);
                                                                                                                        // break;
                                                                                                                    case "list":
                                                                                                                        // isValid = value.split(',').every(item => item.trim().length > 0);
                                                                                                                        // break;
                                                                                                                    case "string":
                                                                                                                    default:
                                                                                                                        isValid = true;
                                                                                                                }
                                                                                                                if (isValid) {
                                                                                                                    handleAttributeChange(attributeIndex, "value", value, setFieldValue, values);
                                                                                                                } else {
                                                                                                                    // Optionally set an error state here
                                                                                                                }
                                                                                                            }}
                                                                                                            onBlur={handleBlur}
                                                                                                        />
                                                                                                    </FormGroup>
                                                                                                </Col>
                                                                                                <Col xxl={2} md={3} lg={2} className="d-flex justify-content-start align-self-center">
                                                                                                    {attributeIndex === 0 ? (
                                                                                                        <i
                                                                                                            className="ri-add-circle-line text-primary fs-3"
                                                                                                            style={{ cursor: 'pointer', marginTop: "-12px" }}
                                                                                                            onClick={() => {
                                                                                                                if (attribute.name && attribute.value) {
                                                                                                                    addAttribute(setFieldValue, values);
                                                                                                                }
                                                                                                            }}
                                                                                                            title="Add Attribute"
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <i
                                                                                                            className="ri-delete-bin-5-line text-danger fs-3"
                                                                                                            style={{ cursor: 'pointer', marginTop: "-12px" }}
                                                                                                            onClick={() => removeAttribute(attributeIndex, setFieldValue, values)}
                                                                                                            title="Delete Attribute"
                                                                                                        />
                                                                                                    )}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        );
                                                                                    })
                                                                                ) : (
                                                                                    <Row className="gy-4 mb-3 align-items-end">
                                                                                        <Col lg={12}>
                                                                                            <p>No attributes available. Click the + button to add attributes.</p>
                                                                                            <i
                                                                                                className="ri-add-circle-line text-primary fs-3"
                                                                                                style={{ cursor: 'pointer' }}
                                                                                                onClick={() => setFieldValue('attributes', [{ name: '', value: '' }])}
                                                                                                title="Add Attribute"
                                                                                            />
                                                                                        </Col>
                                                                                    </Row>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    )}
                                                                    <div lg={12} className="d-flex justify-content-end align-item-center gap-2 mt-3">
                                                                        <CommonButton
                                                                            outline={true}
                                                                            className={
                                                                                "btn-label rv-secondary-btn rounded-1 px-1 ps-3 py-1  w-md-auto text-nowrap"
                                                                            }
                                                                            color={"main-color"}
                                                                            type={"button"}
                                                                            buttonAction={() => {
                                                                                if (showDropdown) {
                                                                                    handleFormReset(resetForm);
                                                                                    setLocalSessionAction('initiate'); // Reset to default
                                                                                } else {
                                                                                    // Only reset sessionAction for view flow, not for simulate flow
                                                                                    const isViewFlow = location.pathname.includes('view-customer');
                                                                                    if (isViewFlow) {
                                                                                        // Reset both session action and local session action for view flow only
                                                                                        if (setSessionAction) {
                                                                                            setSessionAction('');
                                                                                        }
                                                                                        setLocalSessionAction('initiate'); // Reset to default
                                                                                    }
                                                                                    setShowForm(false);
                                                                                }
                                                                            }}
                                                                            buttonText={showDropdown ? "Reset" : "Cancel"}
                                                                            icon={
                                                                                <i className={showDropdown ? "ri-refresh-line label-icon align-middle fs-16 me-1" : "ri-close-fill label-icon align-middle fs-16 me-1"} style={{ transform: showDropdown ? "none" : "scaleX(-1)", borderLeft: "1px solid" }}>
                                                                                </i>
                                                                            }
                                                                            btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                                                        />
                                                                        <CommonButton
                                                                            color={"main-color"}
                                                                            type={"submit"}
                                                                            buttonText={currentSessionAction === "update" ? "Update" : currentSessionAction === "terminate" ? "Terminate" : "Submit"}
                                                                            icon={<i className={currentSessionAction === "update" ? "ri-edit-fill label-icon align-middle fs-16 me-1" : currentSessionAction === "terminate" ? "ri-stop-fill label-icon align-middle fs-16 me-1" : "ri-add-fill label-icon align-middle fs-16 me-1"}></i>}
                                                                            className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1  w-md-auto text-nowrap"
                                                                            btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                                                        />
                                                                    </div>
                                                                </CardBody>
                                                            </Card>
                                                        ) : null
                                                    )
                                                )}
                                            </div>
                                        </Form>
                                    );
                                }}
                            </Formik>
                        )}
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </>
    );
};